import VTeamSelector from '@/views/team/components/v-tree-selector'
import { defaultFun } from '../utils'
import { TEAM_TREE_SELECT } from '../type_name'
import commonMixins from './commonMixins'
import Util from '../../../libs/util';
export default {
    name: TEAM_TREE_SELECT,
    mixins: [ commonMixins ],
    data() {
      return {
        teams: [],
        teams_hash: {}
      }
    },
    created() {
      this.initTree();
    },
    methods: {
      initTree() {
        const data = [];
        const composeTree = (nodes, dep) => {
          for (const item of nodes) {
            dep.push(item.name);
            if (item.id && item.level >= 0) {
              const {children, ...rest} = item
              data.push({
                ...rest,
                full_name: dep.join("/"),
                name: dep.join("/"),
                // todo: 
                del: item.del ? true : false,
              })
            }
            if (item.children && Array.isArray(item.children))composeTree(item.children, dep)
            dep.pop();
          }
        }
        Util.ajax.get(Util.api.team_tree).then(res => {
          console.log(res);
          if (res && res.data && res.data.data && res.data.data.tree_info) {
            const tree = res.data.data.tree_info;
            // 扁平化数据
            composeTree(tree, [])
            this.teams = data;
            // 结构化数据
            const hash = {};
            for (const item of data) {
              hash[item.id] = item;
            }
            this.teams_hash = hash
          }
        })
      },
      
    },
    render(h) {
        const _this = this
        const {
                         // eslint-disable-next-line 
             slots,scopedSlots,
             key,
             allowBlank = false,
             blur = defaultFun,
             change = defaultFun,
             click = defaultFun,
             focus = defaultFun,
             input = defaultFun,
             keydown = defaultFun,
             mousedown = defaultFun,
             mouseup = defaultFun,
             ...params 
            } = this.field
        return h(VTeamSelector, {
            slots: this.slots,
            scopedSlots:  this.separateSlot && this.separateSlot() || {},
            attrs: {
                ...params
              },
            props: {
                allowBlank,
                value: this.my_value[key],
                teams: this.teams,
                teams_hash: this.teams_hash
            },
            on: {
                blur,
                change:(data) => {
                    this.my_value[key] = data
                    change(data, _this.teams_hash[data])
                },
                click,
                focus,
                input,
                keydown,
                mousedown,
                mouseup,
            }
        })
    }
}